import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-logo">
            <Link to="/" className="social-logo">
              BLACK CAT PARANORMAL
            </Link>
          </div>
          <div className="footer-social-icons">
            <a
              className="social-icon-link"
              href="https://www.youtube.com/@Bc.Paranormal"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Youtube"
            >
              <i className="fab fa-youtube" />
            </a>
            <a
              className="social-icon-link"
              href="mailto:the.blackcat.paranormal@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Email"
            >
              <i className="fas fa-envelope" />
            </a>
          </div>
          <small className="website-rights">BLACK CAT PARANORMAL © {new Date().getFullYear()}</small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
